import Component_EdgesRendering_f12d569d3b4bdcba8295336799ad4cb8 from "../../../../content/examples/basic/edges-rendering/EdgesRendering";
import Devtool_EdgesRendering_f12d569d3b4bdcba8295336799ad4cb8 from "!!@devtool/loader!../../../../content/examples/basic/edges-rendering/EdgesRendering";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_EdgesRendering_f12d569d3b4bdcba8295336799ad4cb8,
  Devtool_EdgesRendering_f12d569d3b4bdcba8295336799ad4cb8,
  DevTool,
  React
};